// extracted by mini-css-extract-plugin
export var boxItems = "_96-1";
export var button = "_96-5";
export var filterGroupBox = "_96-0";
export var icon = "_96-2";
export var iconSecondary = "_96-4";
export var iconWrapper = "_96-3";